// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forecast-table-row {
  width: 155vw;
  min-height: 15%;
  display: grid;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  padding: 10px 1rem;
  justify-content: center;
  place-items: center;
  grid-template-columns: 5vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw;
  place-items: center;
}
.forecast-table-row__label {
  font-size: 0.8rem;
}

.bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/forecast-table-row/forecast-table-row.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4EAAA;EACA,mBAAA;AACJ;AAAI;EACI,iBAAA;AAER;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".forecast-table-row{\n    width: 155vw;\n    min-height: 15%;\n    display: grid;\n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    padding: 10px 1rem;\n    justify-content: center;\n    place-items: center;\n    grid-template-columns: 5vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw 15vw;\n    place-items: center;\n    &__label{\n        font-size: 0.8rem;\n    }\n    \n}\n.bold{\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
